import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { TID } from "@/constants/testIds";
import { API_BASE } from "@/lib/api";
import { ClinivonMark } from "@/components/site/Logo";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      if (!res.ok) {
        const j = await res.json().catch(() => ({}));
        throw new Error(j.detail || "Login failed");
      }
      const data = await res.json();
      localStorage.setItem("clinivon_token", data.token);
      localStorage.setItem("clinivon_email", data.email);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-white border border-slate-200 shadow-sm">
        <div className="p-8 border-b border-slate-200">
          <Link to="/" className="flex items-center gap-2.5 mb-6">
            <ClinivonMark size={40} />
            <span className="font-display font-bold text-[#0A2540]">CLINIVON</span>
          </Link>
          <div className="flex items-center gap-2 text-[10px] font-bold tracking-[0.2em] uppercase text-slate-500 mb-2">
            <Lock size={11} /> Admin Access
          </div>
          <h1 className="font-display font-semibold text-2xl text-[#0A2540]">Sign in to dashboard</h1>
          <p className="text-sm text-slate-500 mt-2">Manage submissions and download documents.</p>
        </div>
        <form onSubmit={submit} className="p-8 space-y-4">
          <label className="block">
            <span className="block text-xs font-medium text-slate-600 mb-1.5">Email</span>
            <input
              data-testid={TID.admin.loginEmail}
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-white border border-slate-300 px-3.5 py-2.5 text-sm text-[#0A2540] focus:outline-none focus:border-[#0A2540] focus:ring-1 focus:ring-[#0A2540]"
            />
          </label>
          <label className="block">
            <span className="block text-xs font-medium text-slate-600 mb-1.5">Password</span>
            <input
              data-testid={TID.admin.loginPassword}
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-white border border-slate-300 px-3.5 py-2.5 text-sm text-[#0A2540] focus:outline-none focus:border-[#0A2540] focus:ring-1 focus:ring-[#0A2540]"
            />
          </label>
          <button
            data-testid={TID.admin.loginSubmit}
            disabled={loading}
            className="w-full btn-sharp inline-flex items-center justify-center gap-2 px-5 py-3 bg-[#0A2540] text-white text-sm font-semibold hover:bg-[#061A30] disabled:opacity-60 transition-all"
          >
            {loading ? (<><Loader2 size={14} className="animate-spin" /> Signing in…</>) : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
